export default "__VITE_ASSET__BZVeu2qf__"